// Brand-refresh type and control tokens — the single source of truth the section components share.
// Headings: GT Standard 500, line-height 1.2, one mobile step down. Body: 16/1.5 in the secondary
// gray. CTA links: GT Standard S 700 with a trailing " >". Buttons: 44px, square, near-black.
// Uppercase labels carry no added letter-spacing, matching the caps on viewrail.com.
export const typeScale = {
  h1: 'font-gt text-32 font-medium leading-[1.2] md:text-48',
  h2: 'font-gt text-28 font-medium leading-[1.2] md:text-40',
  h3: 'font-gt text-24 font-medium leading-[1.2] md:text-28',
  h4: 'font-gt text-24 font-medium leading-[1.2]',
  body: 'font-gt text-16 font-normal leading-[1.5] text-[#5e5e5e]',
  /** Body copy on photography or dark panels, where the gray would vanish. */
  bodyOnDark: 'font-gt text-16 font-normal leading-[1.5]',
  eyebrow: 'font-gt text-12 font-bold uppercase',
  /** Bold "Label >" text link; pair with a color class and a min-h-44 tap target on mobile. */
  ctaLink: 'font-gt-s text-14 font-bold hover:underline',
  button:
    'inline-flex h-44 items-center justify-center bg-[#1c1c1c] px-32 font-gt text-14 text-white transition-opacity hover:opacity-90',
  buttonOnDark:
    'inline-flex h-44 items-center justify-center bg-white px-32 font-gt text-14 font-medium text-[#212121] transition-opacity hover:opacity-90',
} as const;

export type TypeToken = keyof typeof typeScale;

// Form control tokens, after the marketing site's lead form: underline-only fields (a 1px rule that
// darkens on focus), 18px entry text with an example as the placeholder, 12px labels above. Shared by
// the login and register forms — they live here rather than on either page so neither owns the other's
// styling.
export const fieldClassName =
  'h-44 w-full border-0 border-b border-[#9e9e9e] bg-transparent px-0 font-gt text-18 text-[#212121] outline-none transition-colors placeholder:text-[#9e9e9e] focus:border-[#212121]';
export const labelClassName = 'font-gt text-12 font-medium text-[#212121]';
// `@tailwindcss/forms` is registered without a strategy, so its base layer already sets
// `appearance: none` and a blue-600 accent on every checkbox and radio — `accent-*` is inert under it.
// These paint the box directly, matching the PLP filter and sort controls.
export const checkboxClassName =
  'size-18 shrink-0 cursor-pointer appearance-none border border-[#9e9e9e] checked:border-[#1c1c1c] checked:bg-[#1c1c1c] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#212121]';
export const radioClassName =
  'size-18 shrink-0 cursor-pointer appearance-none rounded-full border border-[#9e9e9e] checked:border-[5px] checked:border-[#1c1c1c] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#212121]';
export const errorClassName = 'font-gt text-14 leading-[1.4] text-[#D91E28]';
export const sectionTitleClassName = 'font-gt text-20 font-medium leading-[1.2] text-[#212121]';
